<form [formGroup]="form">
  <app-textarea formControlName="prompt" [control]="getControl('prompt')" [label]="'learnset.create_steps.prompt_step.prompt' | translate" [placeholder]="'learnset.create_steps.prompt_step.prompt_placeholder' | translate"></app-textarea>
  
  <app-divider [text]="'oder'"></app-divider>
  
  <app-file-upload (filesChanged)="onFileSelected($event)"></app-file-upload>
  
  <app-select
    formControlName="learncardsRange"
    [control]="getControl('learncardsRange')"
    [label]="'learnset.create_steps.prompt_step.flashcard_count' | translate"
    [options]="['10-20', '20-30', '30-40']">
  </app-select>
</form>